/* eslint-disable @next/next/no-img-element */
import cn from 'classnames'
import Link from 'next/link'
import { FC, useState } from 'react'
import { useRouter } from 'next/router'
import s from './I18nWidgetSideNav.module.css'
import ClickOutside from '@lib/click-outside'
import { useTranslations } from 'next-intl'

interface LOCALE_DATA {
  name: string
  shortname: string
  img: {
    filename: string
    alt: string
  }
}

const LOCALES_MAP: Record<string, LOCALE_DATA> = {
  de: {
    name: 'German',
    shortname: 'DE',
    img: {
      filename: 'flag-de.svg',
      alt: 'German'
    }
  },
  'en': {
    name: 'English',
    shortname: 'EN',
    img: {
      filename: 'flag-en-us.svg',
      alt: 'US Flag'
    }
  }
}

const I18nWidgetSideNav: FC = () => {
  const [display, setDisplay] = useState(false)
  const {
    locale,
    locales,
    defaultLocale = 'de',
    asPath: currentPath
  } = useRouter()

  const t = useTranslations('Global')

  const options = locales?.filter((val) => val !== locale)
  const currentLocale = locale || defaultLocale
  return (
    <ClickOutside active={display} onClick={() => setDisplay(false)}>
      <nav className={s.root + ' relative'}>
        <div
          className='flex items-center relative'
          onClick={() => setDisplay(!display)}
        >
          <button className={s.button} aria-label='Language selector'>
            <span className={'text-black40 mr-10'}>{t('lang')}:</span>
            <span className={'text-black border-b border-black border-solid'}>{t(LOCALES_MAP[currentLocale].shortname)}<span
              className={(display ? 'icon-CaretDown' : 'icon-CaretUp') + ' align-middle ml-2 text-xl'}></span></span>
          </button>
        </div>
        <div className='absolute bottom-12 right-0 left-auto langChooser'>
          {options?.length && display ? (
            <div className={s.dropdownMenu + ' dropdownMenu'}>
              <ul>
                {options.map((locale) => (
                  <li key={locale}>
                    <Link
                      href={currentPath}
                      locale={locale}
                      className={cn(s.item) + ' item'}
                      onClick={() => setDisplay(false)}
                    >
                      {t(LOCALES_MAP[locale].shortname)}
                    </Link>
                  </li>
                ))}
                <li className={s.active + ' active'} key={currentLocale}>
                  <span className={s.item + ' item'}>{t(LOCALES_MAP[currentLocale].shortname)}</span>
                </li>
              </ul>
            </div>
          ) : null}
        </div>
      </nav>
    </ClickOutside>
  )
}

export default I18nWidgetSideNav
